import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import AddIcon from "@mui/icons-material/Add";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { useNavigate } from "react-router-dom";

const CustomerManagementPage: React.FC = () => {
  const navigate = useNavigate();

  const tiles = [
    { title: "Create Customer", icon: <AddIcon />, path: "/dashboard/customers/create" },
    { title: "Manage Customers", icon: <PeopleIcon />, path: "/dashboard/customers/list" },
    { title: "Subaccount Management", icon: <AccountTreeIcon />, path: "/dashboard/customers/subaccounts" },
  ];

  return (
    <Box>
      <Typography variant="h4" sx={{ marginBottom: 2 }}>
        Customer Management
      </Typography>
      <Grid container spacing={3} >
        {tiles.map((tile, index) => (
          <Grid size={{xs:12, sm: 4}} textAlign={"center"} key={index}>
            <Paper
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: 4,
                cursor: "pointer",
                "&:hover": { boxShadow: 6 },
              }}
              onClick={() => navigate(tile.path)}
            >
              {tile.icon}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                {tile.title}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CustomerManagementPage;
